import { Card, Space, Typography } from 'antd';
import type { OrderChannel } from '@erpgold/shared';
import {
  CHANNEL_GROUP_COLOR,
  CHANNEL_GROUP_ICON,
  CHANNEL_GROUP_LABEL,
  CHANNEL_GROUP_MAP,
  type OrderChannelGroup,
} from '../parts/constants';

const { Text } = Typography;

interface Props {
  count_by_channel: Record<OrderChannel, number>;
  active_group?: OrderChannelGroup;
  onSelectGroup: (group: OrderChannelGroup | undefined) => void;
}

const ALL_GROUPS = Object.keys(CHANNEL_GROUP_MAP) as OrderChannelGroup[];

function countOfGroup(
  group: OrderChannelGroup,
  countByChannel: Record<OrderChannel, number>,
): number {
  return CHANNEL_GROUP_MAP[group].reduce(
    (sum, ch) => sum + (countByChannel[ch] ?? 0),
    0,
  );
}

/**
 * 5 channel pills + "Tất cả" pill — count theo channel group.
 * Click pill → set active group filter (undefined = clear filter).
 */
export function OrderSummaryCards({ count_by_channel, active_group, onSelectGroup }: Props) {
  const totalCount = Object.values(count_by_channel).reduce<number>((a, b) => a + b, 0);

  const cardStyle = (selected: boolean) => ({
    minWidth: 130,
    cursor: 'pointer',
    borderColor: selected ? '#a4193d' : undefined,
    borderWidth: selected ? 2 : 1,
    background: selected ? '#fff6f8' : undefined,
  });

  return (
    <Space size={8} wrap style={{ marginBottom: 12 }}>
      <Card
        size="small"
        hoverable
        style={cardStyle(!active_group)}
        styles={{ body: { padding: '8px 12px' } }}
        onClick={() => onSelectGroup(undefined)}
      >
        <Text style={{ fontSize: 12 }}>📋 Tất cả</Text>
        <div style={{ fontSize: 18, fontWeight: 600 }}>{totalCount}</div>
      </Card>
      {ALL_GROUPS.map((g) => (
        <Card
          key={g}
          size="small"
          hoverable
          style={cardStyle(active_group === g)}
          styles={{ body: { padding: '8px 12px' } }}
          onClick={() => onSelectGroup(g)}
        >
          <Text style={{ fontSize: 12 }}>
            {CHANNEL_GROUP_ICON[g]} {CHANNEL_GROUP_LABEL[g]}
          </Text>
          <div
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: countOfGroup(g, count_by_channel) > 0 ? `var(--ant-color-${CHANNEL_GROUP_COLOR[g]}-7, inherit)` : undefined,
            }}
          >
            {countOfGroup(g, count_by_channel)}
          </div>
        </Card>
      ))}
    </Space>
  );
}
